import React,{useRef,useState,useEffect} from 'react'
import JEditor from "jodit-react";
import styled from '@emotion/styled';

const Editor = (props:any) => {
    const editor = useRef<any>();
    const {onChange,value} = props;
    const [content,set_content] = useState<any>(value || "Start Typing");
    const config = {
        readonly: false,
        height: 400
    };
    const handleUpdate = (event:any) => {
        const editorContent = event.innerHTML;
        onChange(editorContent);
        set_content(editorContent);

    };

  return (

    <Wrapper>
        
        <JEditor
                    ref={editor}
                    value={content}
                    config={config}
                    onBlur={handleUpdate}
                    onChange={(e) => handleUpdate}
                />
    </Wrapper>
  )
}

export default Editor;

const Wrapper = styled.div`
    

`